import React, { useEffect, useState } from 'react'
import type { ItemProps, TeamProps } from '../../types'
import styles from './index.module.css'

const Item: React.FC<ItemProps> = (props) => {
    const { type, name, level } = props;
    const [mobile, setMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setMobile(window.innerWidth < 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className={styles.item} style={{
            width: mobile ? 20 : 48,
            height: mobile ? 20 : 48,
        }}>
            <img className={styles.img} src={`/${type === 0 ? 'characters' : 'weapons'}/${name}.png`} alt={name} />
            <div className={styles.level} style={{
                width: mobile ? 8 : 16,
                height: mobile ? 8 : 16,
                fontSize: mobile ? 6 : 16,
                borderBottomRightRadius: mobile ? 2 : 4,
            }}>{level}</div>
        </div>
    )
}

const Team: React.FC<TeamProps> = (props) => {
    const { data } = props;
    const [mobile, setMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setMobile(window.innerWidth < 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className={styles.container} style={{
            gap: mobile ? 1 : 2,
        }}>
            <div className={styles.character} style={{
                gap: mobile ? 1 : 2,
            }}>
                {data.map((item, index) => (
                    <Item key={`char-${index}`} type={0} name={item[0]} level={item[1]} />
                ))}
            </div>
            <div className={styles.weapon} style={{
                gap: mobile ? 1 : 2,
            }}>
                {data.map((item, index) => (
                    <Item key={`weapon-${index}`} type={1} name={item[2]} level={item[3]} />
                ))}
            </div>
        </div>
    )
}

export default Team